/* eslint-disable eag/match-named-export */
import {MutableRefObject} from 'react';

import {GeneratedPlatformDescription} from '@dms/api/sales';

import {createContext} from 'shared/web';

type GeneratedDescriptionsContextType = {
  generatedPlatformDescriptions: GeneratedPlatformDescription[] | null;
  setGeneratedPlatformDescriptions: (value: GeneratedPlatformDescription[] | null) => void;
  resetGeneratedPlatformDescriptions: () => void;
  // Bridge to the general settings form's submit so the platform detail action can
  // save the whole form (PATCH + confirm descriptions). Null while the form is unmounted.
  formSubmitRef: MutableRefObject<(() => Promise<boolean>) | null>;
};

export const [GeneratedDescriptionsContextProvider, useGeneratedDescriptions] =
  createContext<GeneratedDescriptionsContextType>();
